import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { getProductBlockStrategy, getRTL } from '@yme/common/selectors';
import { LOADING_MODEL_TEST_ID } from '@yme/components/View360/constants';
import { selectColorTheme } from '@yme/utils/common';
import { View360Context } from './View360Context';
import { LoadingLabelStyled, LoadingModelStyled, LoadingProgressStyled } from './styled';
export function LoadingModel({ imagesLength, label }) {
    const { imagesLoaderCounter } = useContext(View360Context);
    const isRightToLeft = useSelector(getRTL);
    const productBlockStrategy = useSelector(getProductBlockStrategy);
    const currentColorTheme = selectColorTheme(productBlockStrategy?.value);
    const calcOnePercent = 100 / imagesLength;
    const calcUploadPercents = calcOnePercent * imagesLoaderCounter;
    return (React.createElement(LoadingModelStyled, null,
        React.createElement(LoadingLabelStyled, { isRightToLeft: true }, label),
        React.createElement(LoadingProgressStyled, { uploadPercents: calcUploadPercents, progressBarColor: currentColorTheme, isRightToLeft: isRightToLeft, "data-testid": LOADING_MODEL_TEST_ID })));
}
